<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <h6>Cierres de Caja</h6>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Usuario</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Apertura</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cierre</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Total Apertura</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Total Sistema</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Total Real</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Diferencia</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Estado</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="closure in data" :key="closure.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ closure.user?.name || 'N/A' }}</h6>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ closure.opened_at ? new Date(closure.opened_at).toLocaleString('es-ES') : 'N/A' }}
                      </span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ closure.closed_at ? new Date(closure.closed_at).toLocaleString('es-ES') : 'Abierta' }}
                      </span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ parseFloat(closure.open_total ?? 0).toLocaleString('es-ES', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        }) }}
                      </span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ parseFloat(closure.system_total ?? 0).toLocaleString('es-ES', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        }) }}
                      </span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ parseFloat(closure.actual_total ?? 0).toLocaleString('es-ES', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        }) }}
                      </span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="text-secondary text-xs font-weight-bold" :class="{
                        'text-danger': (closure.difference ?? 0) < 0,
                        'text-success': (closure.difference ?? 0) >= 0
                      }">
                        {{ parseFloat(closure.difference ?? 0).toLocaleString('es-ES', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        }) }}
                      </span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="badge badge-sm" :class="{
                        'bg-gradient-warning': closure.status === 'open',
                        'bg-gradient-success': closure.status === 'closed'
                      }">
                        {{ closure.status === 'open' ? 'Abierta' : 'Cerrada' }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ new Date(closure.created_at).toLocaleDateString('es-ES') }}
                      </span>
                    </td>
                  </tr>

                  <tr v-if="data.length === 0">
                    <td colspan="9" class="text-center text-xxs">No hay registros disponibles</td>
                  </tr>
                </tbody>
              </table>

              <div class="pagination p-3" v-if="links && links.length > 0">
                <a v-for="link in links" :key="link.label" class="page-item cursor-pointer"
                  @click="fetchData(link.url)" :disabled="!link.url || link.active"
                  :class="{ 'active': link.label === currentPage.toString() }">
                  {{ link.label }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CashClosuresList',

  computed: {
    ...mapGetters('cashClosures', ['allData', 'currentPage', 'lastPage', 'pagination', 'links']),
    currentPage() {
      return this.$store.state.cashClosures.currentPage || 1;
    },
    lastPage() {
      return this.$store.state.cashClosures.lastPage || 1;
    },
    data() {
      return this.allData || [];
    },
    links() {
      return this.$store.getters['cashClosures/links'] || [];
    },
  },

  methods: {
    async fetchData(pageUrl = null) {
      const params = pageUrl ? { page: new URL(pageUrl).searchParams.get('page') || 1 } : {};
      await this.$store.dispatch('cashClosures/fetchData', params);
    },
  },

  mounted() {
    this.fetchData();
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.page-item {
  margin: 0 5px;
  padding: 5px 10px;
  cursor: pointer;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.page-item:hover:not(.active):not(:disabled) {
  background-color: #f0f0f0;
}

.page-item.active {
  background-color: #007bff;
  color: white;
  border-color: #007bff;
}

.page-item:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
